import { createSelector, type MemoizedSelector } from '@ngrx/store';
import type { Period } from '../../../interfaces/Building.interface';
import type { AppState } from '../../app.state';
import { selectPagesState } from '../pages.selectors';
import type { ComparisonState, RankingState, State } from './buildings-comparison.state';

const getRankingSection = (state: State): RankingState => state.ranking;
const getComparisonSection = (state: State): ComparisonState => state.comparison;
const getSelectedPeriod = (state: State): Period => state.period;

export const selectBuildingsComparisonStore: MemoizedSelector<AppState, State> = createSelector(
    selectPagesState,
    pagesState => pagesState.buildingsComparison
);

export const selectRankingSection: MemoizedSelector<AppState, RankingState> = createSelector(
    selectBuildingsComparisonStore,
    getRankingSection
);

export const selectComparisonSection: MemoizedSelector<AppState, ComparisonState> = createSelector(
    selectBuildingsComparisonStore,
    getComparisonSection
);

export const selectSelectedPeriod: MemoizedSelector<AppState, Period> = createSelector(
    selectBuildingsComparisonStore,
    getSelectedPeriod
);
